import { ToggleButton as NovaToggleBaseButton, ToggleButtonProps as NovaToggleButtonProps } from '@fme-nova/components'
import { ToggleButton as MuiToggleButtonBase, ToggleButtonProps as MuiToggleButtonProps } from '@mui/material'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'

const MuiToggleButton = styled(MuiToggleButtonBase)`
  border: 1px solid ${COLORS.divider};
  color: ${COLORS.primary.main};

  &:hover {
    background-color: ${COLORS.action.hover};
    color: ${COLORS.text.secondary};
  }

  &:disabled {
    color: ${COLORS.action.disabled};
  }

  &.Mui-selected {
    background-color: ${COLORS.action.selected};
    color: ${COLORS.text.primary};
  }
`

const NovaToggleButton = styled(NovaToggleBaseButton)`
  border: 1px solid ${COLORS.divider};
  color: ${COLORS.primary.main};

  &:hover {
    background-color: ${COLORS.action.hover};
    color: ${COLORS.text.secondary};
  }

  &:disabled {
    color: ${COLORS.action.disabled};
  }

  &.Mui-selected {
    background-color: ${COLORS.action.selected};
    color: ${COLORS.text.primary};
  }
`

export const ToggleButton = createComponentWrapperWithRef<MuiToggleButtonProps | NovaToggleButtonProps>(
  {
    mui: MuiToggleButton,
    nova: NovaToggleButton,
  },
  'ToggleButton',
)
